/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_Group_Cta_TitleInputs */

const en_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Want a private group clinic?`)
};

const es_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Quieres una clínica privada grupal?`)
};

const de_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie einen privaten Gruppenkurs?`)
};

const zh_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`想要私人团体训练班吗？`)
};

const ar_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تريد ورشة جماعية خاصة؟`)
};

const fr_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envie d’un stage privé pour votre groupe ?`)
};

const vi_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muốn lớp chuyên đề nhóm riêng?`)
};

const sw_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unataka mafunzo ya kikundi cha kibinafsi?`)
};

const th_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้องการคลินิกกอล์ฟแบบกลุ่มส่วนตัวไหม?`)
};

const bs_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Želite privatni grupni kurs?`)
};

const ja_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライベートグループクリニックをお探しですか？`)
};

const ko_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프라이빗 그룹 클리닉을 원하시나요?`)
};

const pt_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quer uma clínica particular para seu grupo?`)
};

const it_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuoi un clinic privato per il tuo gruppo?`)
};

const sv_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vill du ha en privat gruppkurs?`)
};

const nl_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een privéclinic voor je groep?`)
};

const da_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vil du have et privat gruppekursus?`)
};

const nb_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ønsker du et privat gruppekurs?`)
};

const fi_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haluatko yksityisen ryhmäkurssin?`)
};

const pl_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chcesz prywatne szkolenie grupowe?`)
};

const ru_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хотите частный групповой мастер-класс?`)
};

const tr_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grubunuza özel bir eğitim programı ister misiniz?`)
};

const hi_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आप अपने समूह के लिए निजी प्रशिक्षण सत्र चाहते हैं?`)
};

const id_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingin kelas kelompok privat?`)
};

const ms_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahukan kelas berkumpulan persendirian?`)
};

const cs_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chcete soukromý skupinový kurz?`)
};

const el_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Θέλετε ιδιωτικό ομαδικό σεμινάριο;`)
};

const he_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`רוצים סדנה פרטית לקבוצה?`)
};

const af_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wil jy 'n privaat groepkursus hê?`)
};

const hu_events_group_cta_title = /** @type {(inputs: Events_Group_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privát csoportos tanfolyamot szeretnél?`)
};

/**
* | output |
* | --- |
* | "Want a private group clinic?" |
*
* @param {Events_Group_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const events_group_cta_title = /** @type {((inputs?: Events_Group_Cta_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_Group_Cta_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_events_group_cta_title(inputs)
	if (locale === "de") return de_events_group_cta_title(inputs)
	if (locale === "zh") return zh_events_group_cta_title(inputs)
	if (locale === "ar") return ar_events_group_cta_title(inputs)
	if (locale === "fr") return fr_events_group_cta_title(inputs)
	if (locale === "vi") return vi_events_group_cta_title(inputs)
	if (locale === "sw") return sw_events_group_cta_title(inputs)
	if (locale === "th") return th_events_group_cta_title(inputs)
	if (locale === "bs") return bs_events_group_cta_title(inputs)
	if (locale === "ja") return ja_events_group_cta_title(inputs)
	if (locale === "ko") return ko_events_group_cta_title(inputs)
	if (locale === "pt") return pt_events_group_cta_title(inputs)
	if (locale === "it") return it_events_group_cta_title(inputs)
	if (locale === "sv") return sv_events_group_cta_title(inputs)
	if (locale === "nl") return nl_events_group_cta_title(inputs)
	if (locale === "da") return da_events_group_cta_title(inputs)
	if (locale === "nb") return nb_events_group_cta_title(inputs)
	if (locale === "fi") return fi_events_group_cta_title(inputs)
	if (locale === "pl") return pl_events_group_cta_title(inputs)
	if (locale === "ru") return ru_events_group_cta_title(inputs)
	if (locale === "tr") return tr_events_group_cta_title(inputs)
	if (locale === "hi") return hi_events_group_cta_title(inputs)
	if (locale === "id") return id_events_group_cta_title(inputs)
	if (locale === "ms") return ms_events_group_cta_title(inputs)
	if (locale === "cs") return cs_events_group_cta_title(inputs)
	if (locale === "el") return el_events_group_cta_title(inputs)
	if (locale === "he") return he_events_group_cta_title(inputs)
	if (locale === "af") return af_events_group_cta_title(inputs)
	if (locale === "hu") return hu_events_group_cta_title(inputs)
	return en_events_group_cta_title(inputs)
});